import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify'
import cookie from 'react-cookies'

export const FETCH_DASHBOARD_UNIT = 'FETCH_DASHBOARD_UNIT'
export const RECEIVE_DASHBOARD_UNIT = 'RECEIVE_DASHBOARD_UNIT'
export const FAILED_DASHBOARD_UNIT = 'RECEIVE_DASHBOARD_UNIT'

export function fetchDashboardUnit(_data){
    return(dispatch, getState) => {
        dispatch({type: FETCH_DASHBOARD_UNIT})
        axios({
            method: 'POST',
            url: API_LINKS.DASHBOARD_UNIT_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: {
                status: 1,
                ..._data
            }
        })
        .then((response) => {
            if(response.status === 200){
                if(response.data.status === "success"){
                    dispatch({
                        type: RECEIVE_DASHBOARD_UNIT,
                        payload: response.data.result
                    })
                } else {
                    dispatch({
                        type: FAILED_DASHBOARD_UNIT
                    })
                }
            } else {
                dispatch({
                    type: FAILED_DASHBOARD_UNIT
                })
            }
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DASHBOARD_UNIT
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 403) {
                    dispatch({
                        type: FAILED_DASHBOARD_UNIT
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DASHBOARD_UNIT
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DASHBOARD_UNIT
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    dispatch({
                        type: FAILED_DASHBOARD_UNIT
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_DASHBOARD_UNIT
                })
                return toast.error('Request have no response! Please check on your internet connection and refresh this page.')
            } else {
                dispatch({
                    type: FAILED_DASHBOARD_UNIT
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/dashboard/aDashboard-Unit.jsx